import { type InferResponseType, unwrap } from "@nexxt/api-client";
import { filterQuery } from "@nexxt/app-kit";
import type { ListWaitingShipmentsInput } from "@nexxt/contracts/logistics";
import { infiniteQueryOptions } from "@tanstack/react-query";
import { api } from "../../api";

// Server state of the shipments of the warehouse Nexxt could not apply (I-11 §5, ADR-130). Applying one changes its
// fulfillment: the retry reloads the fulfillments too (`fulfillmentQueries`).

const waiting = api.logistics["waiting-shipments"];

export type WaitingShipment = InferResponseType<typeof waiting.$get, 200>["items"][number];

/** The filters of the list input (`listWaitingShipmentsInput`), without the paging the queries add. */
export type WaitingShipmentFilters = Pick<ListWaitingShipmentsInput, "reason">;

const PAGE_SIZE = 50;

const all = ["shipments"] as const;

export const shipmentQueries = {
  all,

  waiting: (filters: WaitingShipmentFilters) =>
    infiniteQueryOptions({
      queryKey: [...all, "waiting", filters],
      queryFn: ({ pageParam, signal }) =>
        unwrap(
          waiting.$get(
            { query: { ...filterQuery(filters), page: String(pageParam), pageSize: String(PAGE_SIZE) } },
            { init: { signal } },
          ),
        ),
      initialPageParam: 1,
      getNextPageParam: (last) => (last.hasMore ? last.page + 1 : undefined),
    }),
};
